// extracted by mini-css-extract-plugin
export default {"noMargin":"title_noMargin__7vjDB","titledList":"title_titledList__8+ZnW","chip":"title_chip__qPmm9","normalWeight":"title_normalWeight__toCdi","emphasized":"title_emphasized__lBJry"};